import { Box, Grid, TextField } from "@mui/material";
import { UseControllerProps } from "react-hook-form";
import useSanitizedTextController from "../customHooks/useSanitizedTextController";
import AppInformationText from "./AppInformationText";

interface Props extends UseControllerProps {
    label: string;
    multiline?: boolean;
    rows?: number;
    type?: string;
    information_text?: string | React.ReactNode;
    variant?: "outlined";
    disabled?: boolean;
    maxLength?: number;
    maxStringCount?: number;
}

export default function AppTextInput(props: Props) {
    const { maxLength, maxStringCount, ...textFieldProps } = props;
    const { fieldState, field } = useSanitizedTextController({ ...props, defaultValue: '' });

    return (
        <>
            <Grid container rowSpacing={4}>

                <Grid size={{ xs: 11 }}>
                    <TextField
                        {...textFieldProps}
                        {...field}
                        value={field.value ?? ''}
                        slotProps={{ htmlInput: { maxLength } }}
                        fullWidth
                        error={!!fieldState.error}
                        helperText={maxStringCount != null ? (
                            <Box component="span" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                <Box component="span" sx={{ flex: 1 }}>{fieldState.error?.message}</Box>
                                <Box component="span" sx={{ color: 'text.secondary', flexShrink: 0 }}>
                                    {String(field.value ?? '').length}/{maxStringCount}
                                </Box>
                            </Box>
                        ) : fieldState.error?.message}
                        className="rcsiTextField"
                        sx={props.disabled === true ? { backgroundColor: '#FAFAFA', color: '#858282' } : {}}
                    />
                </Grid>

                <Grid size={{ xs: 1 }}>
                    <AppInformationText information_text={props.information_text} />
                </Grid>

            </Grid>
        </>
    )
}
